import axios from 'axios'

export const getGoogleResponse = (zipcode, token, setLocationOn) => {
  return (dispatch) => {
    dispatch({
      type: 'ALERT_MESSAGE',
      payload: {
        showAlertMessage: false,
        alertMessageType: 'loading',
      },
    })

    axios
      .get(
        `${process.env.REACT_APP_ENITURE_API_URL}/get_loc_from_zip/${zipcode}`,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        if (!data.error) {
          dispatch({
            type: 'GET_GOOGLE_LOCATION_RESPONSE',
            payload: data.data,
          })
        } else {
          dispatch({
            type: 'GET_GOOGLE_LOCATION_RESPONSE',
            payload: null,
          })
        }

        setLocationOn(true)

        dispatch({
          type: 'ALERT_MESSAGE',
          payload: {
            alertMessage: data.message,
            showAlertMessage: data.error,
            alertMessageType: data.error ? 'error' : 'success',
          },
        })
      })
      .catch((error) => {})
  }
}

export const getWarehouse = (
  id,
  setLocationDetail,
  setVisibleWarehouse,
  token
) => {
  return (dispatch) => {
    dispatch({
      type: 'ALERT_MESSAGE',
      payload: {
        showAlertMessage: false,
        alertMessageType: 'loading',
      },
    })

    axios
      .get(`${process.env.REACT_APP_ENITURE_API_URL}/get_location`, {
        params: {
          location_id: id,
        },
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setVisibleWarehouse(true)

        const { data } = res.data

        let additional = JSON.parse(data.additionals)
        let locAssociatedAccNo = JSON.parse(data?.loc_associated_acc_no)
        let fedexLtlDetails = JSON.parse(data?.fedex_ltl_details || '{}')

        setLocationDetail({
          id: data.id ?? '',
          city: data.city ?? '',
          state: data.state ?? '',
          country: data.country ?? '',
          xpo_account_number: locAssociatedAccNo['xpo-ltl'] ?? '',
          odfl_account_number: locAssociatedAccNo['odfl-ltl'] ?? '',
          purolator_account_number: locAssociatedAccNo['purolator-small'] ?? '',
          fedex_account_number: locAssociatedAccNo['fedex-ltl'] ?? '',
          fedex_account_type: fedexLtlDetails?.account_type ?? 'third_party',
          fedex_standard_third_party_account_number: fedexLtlDetails?.standard_third_party_account_number ?? '',
          fedex_standard_account_name: fedexLtlDetails?.standard_account_name ?? '',
          fedex_standard_address: fedexLtlDetails?.standard_address ?? '',
          fedex_standard_city: fedexLtlDetails?.standard_city ?? '',
          fedex_standard_state: fedexLtlDetails?.standard_state ?? '',
          fedex_standard_zip: fedexLtlDetails?.standard_zip ?? '',
          fedex_standard_country: fedexLtlDetails?.standard_country ?? '',
          fedex_standard_test_type: fedexLtlDetails?.standard_test_type ?? 'shipper',
          fedex_direct_account_number: fedexLtlDetails?.direct_account_number ?? '',
          fedex_direct_third_party_account_number: fedexLtlDetails?.direct_third_party_account_number ?? '',
          fedex_direct_account_name: fedexLtlDetails?.direct_account_name ?? '',
          fedex_direct_address: fedexLtlDetails?.direct_address ?? '',
          fedex_direct_city: fedexLtlDetails?.direct_city ?? '',
          fedex_direct_state: fedexLtlDetails?.direct_state ?? '',
          fedex_direct_zip: fedexLtlDetails?.direct_zip ?? '',
          fedex_direct_country: fedexLtlDetails?.direct_country ?? '',
          fedex_direct_test_type: fedexLtlDetails?.direct_test_type ?? 'shipper',
          saia_account_number: locAssociatedAccNo['saia-ltl'] ?? '',
          sefl_account_number: locAssociatedAccNo['southeastern-ltl'] ?? '',
          tforce_payor_country: additional?.tforce?.payor_country ?? '',
          tforce_payor_postal_code: additional?.tforce?.payor_postal_code ?? '',
          nickname: data.nickname ?? '',
          zip_code: data.zip_code ?? '',
          location_type: data.type ?? '',
          address: data.address ?? '',
          phone: data.phone ?? '',
          caller_name: additional?.caller_name ?? '',
          caller_phone_number: additional?.caller_phone_number ?? '',
          origin_markup: data.origin_markup ?? '',

          enable_instore: additional.instore_pickup ?? false,
          enable_instore_distance: additional?.enable_instore_distance ?? false,
          enable_instore_address: additional?.enable_instore_address ?? false,
          enable_instore_phone: additional?.enable_instore_phone ?? false,
          residential_pickup_parcel: additional?.residential_pickup_parcel ?? false,
          residential_pickup_ltl: additional?.residential_pickup_ltl ?? false,
          liftgate_pickup_ltl: additional?.liftgate_pickup_ltl ?? false,
          instore_miles: additional.instore_pickup_data.miles ?? null,
          instore_zipcodes:
            additional.instore_pickup_data.postalCodes.length > 0
              ? additional.instore_pickup_data.postalCodes.split(',')
              : [],
          instock_description:
            additional.instore_pickup_data.checkout_description ?? null,
          default_location_id: data?.default_location_id
            ? isNaN(data?.default_location_id)
              ? data?.default_location_id
              : parseInt(data?.default_location_id)
            : 'default',
          instore_postalCode:
            additional?.instore_pickup_data?.instore_postalCode ?? '',
          instore_city: additional?.instore_pickup_data?.instore_city ?? null,
          instore_state: additional?.instore_pickup_data?.instore_state ?? null,
          instore_country:
            additional?.instore_pickup_data?.instore_country ?? null,

          enable_ld: additional.local_delivery ?? false,
          ld_miles: additional.local_delivery_data.miles ?? null,
          ld_zipcodes:
            additional.local_delivery_data.postalCodes.length > 0
              ? additional.local_delivery_data.postalCodes.split(',')
              : [],
          ld_description:
            additional.local_delivery_data.checkout_description ?? null,
          ld_fee: additional.local_delivery_data.local_delivery_fee ?? null,

          ld_enable_supress: additional.ld_enable_supress ?? false,
        })

        dispatch({
          type: 'ALERT_MESSAGE',
          payload: {
            alertMessage: data.message,
            showAlertMessage: data.error,
            alertMessageType: data.error ? 'error' : 'success',
          },
        })
      })
  }
}

export const deleteLocation = (id, type, setDeleteWarehouseModal, token) => {
  return (dispatch) => {
    dispatch({
      type: 'ALERT_MESSAGE',
      payload: {
        showAlertMessage: true,
        alertMessageType: 'loading',
      },
    })

    axios
      .post(
        `${process.env.REACT_APP_ENITURE_API_URL}/delete_location`,
        {
          location_id: id,
          location_type: type === 1 ? 'Warehouse' : 'Drop ship',
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then(({ data }) => {
        if (!data.error) {
          dispatch({
            type: 'DELETE_LOCATION',
            payload: id,
          })

          setDeleteWarehouseModal(false)
        }

        dispatch({
          type: 'ALERT_MESSAGE',
          payload: {
            alertMessage: data.message,
            showAlertMessage: true,
            alertMessageType: data.error ? 'error' : 'success',
          },
        })
      })
  }
}

export const getLocations = (token) => {
  const config = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  }

  return (dispatch) => {
    axios
      .get(`${process.env.REACT_APP_ENITURE_API_URL}/get_locations`, config)
      .then(async ({ data }) => {
        if (data.data.length > 0) {
          let dropships = []
          let warehouse = []

          await data.data.forEach((value) =>
            value.type === 1
              ? (warehouse = [...warehouse, value])
              : (dropships = [...dropships, value])
          )

          dispatch({
            type: 'GET_LOCATIONS',
            payload: {
              dropships: dropships,
              warehouse: warehouse,
            },
          })
        }
      })
      .catch(({ response }) => {
        if (
          response &&
          response.data.error &&
          response.data.message === 'Token Mismatch'
        ) {
          dispatch({
            type: 'GET_CARRIERS',
            payload: undefined,
          })

          dispatch({
            type: 'ALERT_MESSAGE',
            payload: {
              showAlertMessage: false,
              alertMessageType: 'Token Mismatch',
            },
          })
        }
      })
  }
}
